import { BestRequestsNav } from './BestRequestsNav';

export default BestRequestsNav;
